import {Component, Input, OnDestroy, OnInit} from "@angular/core";
import {StatusBar, Style} from "@capacitor/status-bar";
import {Capacitor} from "@capacitor/core";
import {Toast, ToastPackage, ToastrService} from 'ngx-toastr';

@Component({
    templateUrl: "./toast.component.html",
    styleUrls: ["./toast.component.scss"],
    preserveWhitespaces: false,
})

export class ToastComponent extends Toast implements OnInit, OnDestroy {

    @Input() _onClickAction?: () => void;
    
    constructor(
        protected toastrService: ToastrService,
        public toastPackage: ToastPackage,
    ) {
        super(toastrService, toastPackage);
    }

    previousStatusbarStyle?:Style;

    ngOnInit(): void {
        this.changeStatusBarStyle();
    }

    ngOnDestroy(): void {
        this.restoreStatusBarStyle();
    }

    private async changeStatusBarStyle() {
        if (!Capacitor.isNativePlatform()) {
            return;
        }
        this.previousStatusbarStyle = await StatusBar.getInfo().then(info => info.style);
        await StatusBar.setStyle({ style: Style.Dark });
    }



    private async restoreStatusBarStyle() {
        if (!Capacitor.isNativePlatform()) {
            return;
        }
        if (this.previousStatusbarStyle) {
            await StatusBar.setStyle({ style: this.previousStatusbarStyle });
        }
    }

    onClickAction() {
        this._onClickAction?.();
        this.remove();
    }
}
